import { useDocumentTabDataContext } from 'features/knowledgeDocumentViewer/contexts/DocumentTabDataContext'
import { resolveDerivedPageImageFileRef } from 'features/knowledgeDocumentViewer/utils/documentPageImages'
import { useMemo } from 'react'
import type { RolodexFilePath } from 'types'

type ImageVariant = 'thumbnail' | 'hiRes'

/**
 * UUID5-derived page-image file ref for the open document tab.
 */
export function useViewerCantileverPageImageRef(
  pageNumber: number,
  variant: ImageVariant
): RolodexFilePath | undefined {
  const { siteID, imageDocumentId } = useDocumentTabDataContext()

  return useMemo(
    () =>
      resolveDerivedPageImageFileRef({
        siteId: siteID,
        bqDocumentId: imageDocumentId,
        pageNumber,
        variant,
      }),
    [imageDocumentId, pageNumber, siteID, variant]
  )
}
